(function($) {
  $(document).on('click', '.prevent-default > a', event => event.preventDefault())
})(jQuery);